<template>
	<div data-tour-scope="setting-framework">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.subsetting.framework') }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>
							<v-spacer></v-spacer>
						</v-toolbar>


						<v-data-table
							:headers="headers"
							class="elevation-0 cellanowrap"
							:hide-default-header="isMobile || mobileCards"
							:class="{ mobile: isMobile, 'table-cards': mobileCards }"
							hide-default-footer
							disable-pagination
							disable-sort
							item-key="item._id"
							data-tour="table"
						>
							<template v-slot:body>
								<!-- telefono: ogni CMS diventa una card, la configurazione si apre dentro la card -->
								<tbody v-if="mobileCards" class="framework-cards">
									<tr v-for="s in servizi" :key="s.key">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card>
												<template v-slot:title>
													<span class="d-inline-flex align-center">
														<v-avatar size="24px" tile class="mr-2"><img :src="s.logo" :alt="s.nome" /></v-avatar>
														{{ s.nome }}
													</span>
												</template>
												<template v-slot:actions>
													<v-switch v-model="modello(s).active" @change="saveSetting(s.indice)" color="primary" class="mt-0 pt-0 mr-2" hide-details></v-switch>
													<v-btn small icon color="primary" :data-tour="s.indice === 0 ? 'expand' : null" :title="checkpresenza(s.indice) ? 'Chiudi' : 'Impostazioni'" @click="extension(s.indice)">
														<v-icon>{{ checkpresenza(s.indice) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
													</v-btn>
												</template>
												<service-panel
													v-if="checkpresenza(s.indice)"
													:servizio="s"
													:modello="modello(s)"
													:intestazione="false"
													:data-tour="s.indice === 0 ? 'settings' : null"
													@save="saveSetting(s.indice)"
												>
													<div v-if="s.video" class="fw-video">
														<div class="fw-video-caption">
															<v-avatar size="20px" tile class="mr-2"><img :src="require('@/assets/images/video/youtube-3.svg')" alt="YouTube" /></v-avatar>
															Video per la creazione dell'app su Shopify e configurazione su Az Seller
														</div>
														<youtube :video-id="videoshopify" player-width="100%"></youtube>
													</div>
													<template v-slot:azioni>
														<v-btn v-if="s.connessione" small outlined color="primary" @click="openConnectionCheck(s.connessione)"><v-icon left small>mdi-connection</v-icon>Verifica connessione</v-btn>
														<v-spacer></v-spacer>
													</template>
												</service-panel>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<template v-for="s in servizi">
										<tr :key="s.key" class="as-list-row" :class="{ 'as-list-row--open': checkpresenza(s.indice) }" @click="extension(s.indice)">
											<td class="pr-0" style="width: 40px">
												<v-btn small icon :data-tour="s.indice === 0 ? 'expand' : null" :title="checkpresenza(s.indice) ? 'Chiudi' : 'Impostazioni'" @click.stop="extension(s.indice)">
													<v-icon>{{ checkpresenza(s.indice) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
												</v-btn>
											</td>
											<td>
												<v-avatar size="32px" tile>
													<img :src="s.logo" :alt="s.nome" />
												</v-avatar>
												{{ s.nome }}
											</td>
											<td @click.stop>
												<v-switch v-model="modello(s).active" @change="saveSetting(s.indice)" color="primary" class="mt-0" hide-details></v-switch>
											</td>
										</tr>
										<tr v-if="checkpresenza(s.indice)" :key="s.key + '-panel'" class="as-expanded">
											<td :colspan="headers.length" class="py-3">
												<service-panel :servizio="s" :modello="modello(s)" :data-tour="s.indice === 0 ? 'settings' : null" @save="saveSetting(s.indice)">
													<div v-if="s.video" class="fw-video">
														<div class="fw-video-caption">
															<v-avatar size="20px" tile class="mr-2"><img :src="require('@/assets/images/video/youtube-3.svg')" alt="YouTube" /></v-avatar>
															Video per la creazione dell'app su Shopify e configurazione su Az Seller
														</div>
														<youtube :video-id="videoshopify" player-width="100%"></youtube>
													</div>
													<template v-slot:azioni>
														<v-btn v-if="s.connessione" small outlined color="primary" @click="openConnectionCheck(s.connessione)"><v-icon left small>mdi-connection</v-icon>Verifica connessione</v-btn>
														<v-spacer></v-spacer>
													</template>
												</service-panel>
											</td>
										</tr>
									</template>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>
		<TourOverlay :tour="tour"></TourOverlay>
		<marketplace-connection-check v-model="connectionCheck.open" :service="connectionCheck.service"></marketplace-connection-check>
	</div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import ServicePanel from './components/ServicePanel.vue';
import MarketplaceConnectionCheck from './components/MarketplaceConnectionCheck.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createFrameworkTourSteps, stopFrameworkTour } from './framework-tour';

export default {
	name: 'Framework',
	setup() {
		return { tour: useTour(createFrameworkTourSteps(), { onStop: stopFrameworkTour }) };
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
	data() {
		return {
			videoshopify: 'zWwS_NJjKOA',
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// riquadri di configurazione aperti (indice del servizio)
			selected: [],
			// verifica connessione: verifica le impostazioni salvate
			connectionCheck: { open: false, service: 'shopify' },
			headers: [{ text: '', sortable: false }, { text: 'CMS', sortable: false }, { text: 'Status', sortable: false }],
			messages: {
				email: [],
				name: [],
				password: [],
			},

			isMobile: false,

			magento: {
				active: '',
				setting: {
					host: '',
					path: '',
					port: '',
					consumerKey: '',
					consumerSecret: '',
					accessToken: '',
					tokenSecret: '',
				},
				type: 'framework',
				service: 'magento',
			},
			prestashop: {
				active: '',
				setting: {},
				type: 'framework',
				service: 'prestashop',
			},
			shopify: {
				active: '',
				setting: {
					shop: '',
					api_key: '',
					password: '',
					shared_secret: '',
					items: true,
					quantity: true,
					category: true,
					order: true,
				},
				type: 'framework',
				service: 'shopify',
			},
			woocommerce: {
				active: '',
				setting: {},
				type: 'framework',
				service: 'woocommerce',
			},
			website: {
				active: '',
				setting: {
					items: true,
					quantity: true,
					category: true,
					order: true,
				},
				type: 'framework',
				service: 'website',
			},

			// righe della tabella: indice = argomento di saveSetting/extension, key = oggetto in data
			servizi: [
				{
					indice: 0,
					key: 'magento',
					nome: 'Magento >= 2',
					logo: require('@/assets/images/framework/Magento.svg'),
					campi: [
						{ key: 'host', label: 'Host' },
						{ key: 'path', label: 'Path' },
						{ key: 'accessToken', label: 'Access Token' },
						{ key: 'tokenSecret', label: 'Token Secret' },
						{ key: 'consumerKey', label: 'Consumer Key' },
						{ key: 'consumerSecret', label: 'Consumer Secret' },
						{ key: 'port', label: 'Porta' },
					],
				},
				{ indice: 1, key: 'prestashop', nome: 'Prestashop >= 1.7', logo: require('@/assets/images/framework/prestashop.svg'), campi: [], prossimamente: true },
				{
					indice: 2,
					key: 'shopify',
					connessione: 'shopify',
					nome: 'Shopify',
					logo: require('@/assets/images/framework/shopify.svg'),
					video: true,
					campi: [
						{ key: 'shop', label: 'Shop' },
						{ key: 'api_key', label: 'Api Key' },
						{ key: 'password', label: 'Password' },
						{ key: 'shared_secret', label: 'Shared secret' },
						{ key: 'items', label: 'Anagrafica prodotti', tipo: 'switch' },
						{ key: 'quantity', label: 'Giacenze prodotti', tipo: 'switch' },
						{ key: 'category', label: 'Categorie', tipo: 'switch' },
						{ key: 'order', label: 'Ordini', tipo: 'switch' },
					],
				},
				{ indice: 3, key: 'woocommerce', nome: 'Woocommerce', logo: require('@/assets/images/framework/woocommerce.svg'), campi: [], prossimamente: true },
				{
					indice: 4,
					key: 'website',
					nome: 'Sito internet',
					logo: require('@/assets/images/framework/world-wide-web.svg'),
					campi: [
						{ key: 'items', label: 'Anagrafica prodotti', tipo: 'switch' },
						{ key: 'quantity', label: 'Giacenze prodotti', tipo: 'switch' },
						{ key: 'category', label: 'Categorie', tipo: 'switch' },
						{ key: 'order', label: 'Ordini', tipo: 'switch' },
					],
				},
			],
		};
	},
	filters: {
		fixed: function (value) {
			if (!+value) return '';
			return _.round(value, 2);
		},
	},
	async created() {
		this.setPreload(true);
		let promises = [];
		promises.push(this.fetchSettings());
		promises.push(this.fetchService(['magento', 'prestashop', 'shopify', 'woocommerce', 'website']));
		await Promise.all(promises);

		this.setPreload(false);

		let magento = _.find(this.getServices, set => {
			return set.service === 'magento';
		});
		if (magento) {
			this.magento = magento;
		}
		let prestashop = _.find(this.getServices, set => {
			return set.service === 'prestashop';
		});
		if (prestashop) {
			this.prestashop = prestashop;
		}
		let shopify = _.find(this.getServices, set => {
			return set.service === 'shopify';
		});
		if (shopify) {
			this.shopify = {
				active: shopify.active,
				setting: {
					shop: shopify.setting?.shop ? shopify.setting.shop : '',
					api_key: shopify.setting?.api_key ? shopify.setting.api_key : '',
					password: shopify.setting?.password ? shopify.setting.password : '',
					shared_secret: shopify.setting?.shared_secret ? shopify.setting.shared_secret : '',
					items: shopify.setting?.items ? shopify.setting.items : false,
					quantity: shopify.setting?.quantity ? shopify.setting.quantity : false,
					category: shopify.setting?.category ? shopify.setting.category : false,
					order: shopify.setting?.order ? shopify.setting.order : false,
				},
				type: 'framework',
				service: 'shopify',
			};
		}
		let woocommerce = _.find(this.getServices, set => {
			return set.service === 'woocommerce';
		});
		if (woocommerce) {
			this.woocommerce = woocommerce;
		}

		let website = _.find(this.getServices, set => {
			return set.service === 'website';
		});
		if (website) {
			this.website = website;
		}
	},

	components: {
		TourOverlay,
		KeyValueCard,
		ServicePanel,
		MarketplaceConnectionCheck,
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getSettings: 'settings/getSetting',
			getDrawerFilter: 'settings/getDrawerFilter',

			getServices: 'services/getServices',
		}),
	},

	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',
			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchSettings: 'settings/asyncFetchData',
			fetchService: 'services/getServiceFetch',

			destroyData: 'settings/destroyData',
			setSettings: 'settings/updateData',
			setService: 'services/updateData',
		}),

		onResize() {
			this.isMobile = window.innerWidth < 769;
		},

		saveSetting(item) {
			let payload;
			switch (item) {
				case 0:
					payload = this.magento;
					this.setPreload(true);
					break;
				case 1:
					payload = this.prestashop;
					this.setPreload(true);
					break;
				case 2:
					payload = this.shopify;
					this.setPreload(true);
					break;
				case 3:
					payload = this.woocommerce;
					this.setPreload(true);
					break;
				case 4:
					payload = this.website;
					this.setPreload(true);
					break;
			}
			let url = 'services/update';
			axios
				.post(`${this.getUrl}${url}`, payload, {
					headers: { Authorization: `Bearer ${this.getToken}` },
				})
				.then(({ data }) => {
					this.setService(data.data);
					this.setPreload(false);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.setPreload(false);
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		extension(item) {
			let check = this.selected.includes(item);
			if (!check) {
				this.selected.push(item);
			} else {
				let index = this.selected.indexOf(item);
				this.selected.splice(index, 1);
			}
		},
		openConnectionCheck(service) {
			this.connectionCheck.service = service;
			this.connectionCheck.open = true;
		},
		checkpresenza(item) {
			return this.selected.includes(item);
		},
		// oggetto in data del CMS (magento, shopify, ...): created() lo sostituisce, quindi va letto ogni volta
		modello(servizio) {
			return this[servizio.key];
		},
	},
};
</script>

<style></style>

<style scoped>
/* lista compatta: la riga aperta si colora e sotto compare il riquadro di configurazione */
.as-list-row {
	cursor: pointer;
}
.as-list-row--open,
.as-list-row--open:hover {
	background: #f3f6fa !important;
}
.as-expanded,
.as-expanded:hover {
	background: transparent !important;
}
/* video Shopify in cima al riquadro */
.fw-video {
	max-width: 560px;
	margin-bottom: 16px;
}
.fw-video-caption {
	display: flex;
	align-items: center;
	font-size: 13px;
	color: #5f6b7a;
	margin-bottom: 6px;
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.framework-cards,
.framework-cards tr {
	display: block;
	width: 100%;
}
.framework-cards tr,
.framework-cards tr:hover {
	background: transparent !important;
}
.framework-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.framework-cards tr:first-child td {
	padding-top: 12px !important;
}
.framework-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.framework-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
/* card in lista fuori da v-data-table */
.kv-list > .kv-card + .kv-card {
	margin-top: 8px;
}
</style>
